import { render, staticRenderFns } from "./AdminUserManager.vue?vue&type=template&id=4453c6d4&scoped=true"
import script from "./AdminUserManager.vue?vue&type=script&lang=js"
export * from "./AdminUserManager.vue?vue&type=script&lang=js"
import style0 from "./AdminUserManager.vue?vue&type=style&index=0&id=4453c6d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4453c6d4",
  null
  
)

export default component.exports